module.exports = __webpack_public_path__ + "static/media/footer-icon-dark-6.3dc8eaf6.svg";